module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DIV', {
    staticClass: "content-wrapper"
  }, [(_vm.serverData.loadingDataStatus.mainCommonData != _vm.serverData.loadingDataStatus.types.LOADED) ? _c('div', {
    staticClass: "loading-text"
  }, [_vm._v("\n  Подождите, загружаются общие данные\n")]) : (_vm.serverData.loadingDataStatus.events != _vm.serverData.loadingDataStatus.types.LOADED) ? _c('div', {
    staticClass: "loading-text"
  }, [_vm._v("\n  Подождите, загружаются данные по событиям\n")]) : (_vm.event == null) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "float": "left"
    }
  }, [_c('div', {
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-arrow-circle-left back-button"
  })]), _vm._v(" "), _c('div', {
    staticClass: "eventnotfound-text"
  }, [_vm._v("Событие не найдено или устарело")])]) : _c('div', {
    staticClass: "event"
  }, [_c('DIV', {
    staticClass: "event_part1"
  }, [_c('div', {
    staticClass: "event-image",
    style: ({
      'background-image': 'url(' + _vm.serverData.imagesGetURL(_vm.event.val.body.images[0]) + ')'
    }),
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-arrow-circle-left back-button-over"
  }), _vm._v(" "), (_vm.isActiveUserOwnerOfEventOrAdmin()) ? _c('i', {
    staticClass: "fas fa-edit back-button-over-right",
    on: {
      "click": function($event) {
        _vm.goToEventEdit(_vm.event.val.id)
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "padding": "10px 0 0 0",
      "float": "left"
    }
  }, [_c('div', {
    staticClass: "event-name"
  }, [_vm._v(_vm._s(_vm.event.val.name))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "padding": "10px 0 0 0",
      "float": "left"
    }
  }, [(_vm.event.val.status != 1) ? _c('div', {
    staticClass: "event-status",
    style: ({
      'background': _vm.getEventStatusBackground()
    })
  }, [_vm._v("\n      " + _vm._s(_vm.getEventStatusText())), _c('br'), _vm._v("по причине: " + _vm._s(_vm.event.val.body.cancelReason) + "\n    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "padding": "10px 0 0 0",
      "text-align": "left",
      "float": "left"
    }
  }, [_c('div', {
    staticClass: "event-prop link",
    on: {
      "click": function($event) {
        _vm.goToUserCard(_vm.event.val.createdBy)
      }
    }
  }, [_c('div', {
    staticClass: "event-user-avatar",
    style: ({
      'background-image': 'url(' + _vm.serverData.imagesGetURL(_vm.getUser(_vm.event.val.createdBy).body.avatar) + ')'
    })
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "calc(100% - 70px)",
      "padding-top": "10px",
      "float": "right"
    }
  }, [_vm._v("\n        Организатор:"), _c('br'), _vm._v("\n        " + _vm._s(_vm.getUser(_vm.event.val.createdBy).name)), _c('br'), _vm._v(" "), (_vm.getUser(_vm.event.val.createdBy).phone != null) ? _c('span', {
    staticStyle: {
      "font-size": "11px"
    }
  }, [_vm._v(" (+" + _vm._s(_vm.getUser(_vm.event.val.createdBy).phone) + ")")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "padding": "10px 0 0 0",
      "text-align": "left",
      "float": "left"
    }
  }, [_c('div', {
    staticClass: "event-prop link",
    on: {
      "click": function($event) {
        _vm.goToPlaceCard(_vm.event.val.place)
      }
    }
  }, [_c('div', {
    staticClass: "event-place-image",
    style: ({
      'background-image': 'url(' + _vm.serverData.imagesGetURL(_vm.serverData.placesMap[_vm.event.val.place].val.images[0]) + ')'
    })
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "calc(100% - 70px)",
      "float": "left"
    }
  }, [_vm._v("\n        Место:"), _c('br'), _vm._v("\n        " + _vm._s(_vm.serverData.placesMap[_vm.event.val.place].val.name)), _c('br'), _vm._v("\n        " + _vm._s(_vm.serverData.placesMap[_vm.event.val.place].val.city) + ", " + _vm._s(_vm.serverData.placesMap[_vm.event.val.place].val.address) + "\n      ")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "50%",
      "padding": "0px 0 0 0",
      "text-align": "left",
      "float": "left"
    }
  }, [_c('div', {
    staticClass: "event-prop",
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_vm._v("\n      Дата: " + _vm._s(_vm._f("formatDate")(_vm.event.val.dateStart, 'date + weekday')) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "event-prop"
  }, [_vm._v("\n      Время: " + _vm._s(_vm.event.val.timeStart) + " - " + _vm._s(_vm.event.val.timeEnd) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "50%",
      "padding": "0px 0 0 0",
      "text-align": "right",
      "float": "left"
    }
  }, [(_vm.event.val.price > 0) ? _c('div', {
    staticClass: "event-prop",
    staticStyle: {
      "padding-top": "42px"
    }
  }, [_vm._v("Стоимость: " + _vm._s(_vm.event.val.price) + " р")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "calc(100% - 50px)",
      "margin": "20px 25px 0 25px",
      "background": "#f9f9f9",
      "border-radius": "10px",
      "float": "left"
    }
  }, [_c('div', {
    staticClass: "event-prop",
    staticStyle: {
      "padding": "15px 20px 20px 20px"
    },
    attrs: {
      "id": "eventDescription"
    }
  }, [_vm._v(" ")])])]), _vm._v(" "), (_vm.activeUser == null) ? _c('DIV', {
    staticClass: "event_part2",
    staticStyle: {
      "padding": "0 25px 0 25px",
      "text-align": "center"
    }
  }, [_vm._v("\n    Войдите в систему, чтобы принять участие в событии\n  ")]) : _vm._e(), _vm._v(" "), ((_vm.activeUser != null)) ? _c('DIV', {
    staticClass: "event_part2"
  }, [(((_vm.eventMembering.myMembering == null) || (_vm.eventMembering.myMembering.val.status != 1) || (_vm.eventMembering.myMembering.val.participationType == 2))) ? _c('Button', {
    staticClass: "button-primary",
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.subscribe(1)
      }
    }
  }, [_vm._v("Участвую")]) : _vm._e(), _vm._v(" "), (((_vm.eventMembering.myMembering == null) || (_vm.eventMembering.myMembering.val.status != 1) || (_vm.eventMembering.myMembering.val.participationType == 1))) ? _c('Button', {
    staticClass: "button-primary",
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.subscribe(2)
      }
    }
  }, [_vm._v("Возможно")]) : _vm._e(), _vm._v(" "), (((_vm.eventMembering.myMembering != null) && (_vm.eventMembering.myMembering.val.status == 1))) ? _c('Button', {
    staticClass: "button-primary",
    staticStyle: {
      "color": "#fff",
      "background": "#777"
    },
    attrs: {
      "type": "ghost",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.unsubscribe()
      }
    }
  }, [_vm._v("Не участвую")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "padding": "0px 0 20px 0",
      "float": "left"
    }
  }, [_c('div', {
    staticClass: "event-prop"
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "600"
    }
  }, [_vm._v("Участников:")]), _vm._v(" " + _vm._s(_vm.event.membering.members.length) + " "), (_vm.event.membering.possible.length > 0) ? _c('span', [_vm._v("(+" + _vm._s(_vm.event.membering.possible.length) + " возможно)")]) : _vm._e(), _vm._v(" (мин: " + _vm._s(_vm.event.val.body.membersLimitFrom) + " макс: " + _vm._s(_vm.event.val.body.membersLimitTo) + ")\n      ")])]), _vm._v(" "), (_vm.event.membering.members.length > 0) ? _c('DIV', {
    staticStyle: {
      "width": "100%",
      "margin-bottom": "20px",
      "float": "left"
    }
  }, [_c('div', {
    staticClass: "event-member",
    staticStyle: {
      "font-weight": "600",
      "margin": "0px 0 5px 0"
    }
  }, [_vm._v("Участники:")]), _vm._v(" "), _vm._l((_vm.event.membering.members), function(eventMember, keyM) {
    return _c('div', {
      key: keyM,
      staticClass: "event-member link",
      on: {
        "click": function($event) {
          _vm.goToUserCard(eventMember.val.refToUser)
        }
      }
    }, [_c('div', {
      staticClass: "event-user-avatar-small",
      style: ({
        'background-image': 'url(' + _vm.serverData.imagesGetURL(_vm.getUser(eventMember.val.refToUser).body.avatar) + ')'
      })
    }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
      staticClass: "event-user-text",
      style: ({
        'padding-top': _vm.isActiveUserOwnerOfEventOrAdmin() ? '4px' : '11px'
      })
    }, [_vm._v("\n        " + _vm._s(_vm.getUser(eventMember.val.refToUser).name)), _c('br'), _vm._v(" "), ((eventMember.val.refToUser != _vm.activeUser.id) && (_vm.getUser(eventMember.val.refToUser).phone != null)) ? _c('span', {
      staticStyle: {
        "font-size": "11px"
      }
    }, [_vm._v("+" + _vm._s(_vm.getUser(eventMember.val.refToUser).phone))]) : _vm._e(), _vm._v(" "), (_vm.isActiveUserOwnerOfEventOrAdmin()) ? _c('span', {
      staticStyle: {
        "font-size": "11px"
      }
    }, [_vm._v(", " + _vm._s(eventMember.val.price) + " р")]) : _vm._e(), _vm._v(" "), (_vm.isActiveUserOwnerOfEventOrAdmin()) ? _c('span', {
      staticStyle: {
        "font-size": "11px"
      }
    }, [_vm._v(", " + _vm._s(eventMember.val.participated == true ? 'участвовал' : 'не участвовал'))]) : _vm._e()])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.event.membering.possible.length > 0) ? _c('DIV', {
    staticStyle: {
      "width": "100%",
      "margin-bottom": "20px",
      "float": "left"
    }
  }, [_c('div', {
    staticClass: "event-member",
    staticStyle: {
      "font-weight": "600",
      "margin": "0px 0 5px 0"
    }
  }, [_vm._v("Возможно:")]), _vm._v(" "), _vm._l((_vm.event.membering.possible), function(eventMember, keyP) {
    return _c('div', {
      key: keyP,
      staticClass: "event-member link",
      on: {
        "click": function($event) {
          _vm.goToUserCard(eventMember.val.refToUser)
        }
      }
    }, [_c('div', {
      staticClass: "event-user-avatar-small",
      style: ({
        'background-image': 'url(' + _vm.serverData.imagesGetURL(_vm.getUser(eventMember.val.refToUser).body.avatar) + ')'
      })
    }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
      staticClass: "event-user-text",
      style: ({
        'padding-top': _vm.isActiveUserOwnerOfEventOrAdmin() ? '4px' : '11px'
      })
    }, [_vm._v("\n        " + _vm._s(_vm.getUser(eventMember.val.refToUser).name)), _c('br'), _vm._v(" "), ((eventMember.val.refToUser != _vm.activeUser.id) && (_vm.getUser(eventMember.val.refToUser).phone != null)) ? _c('span', {
      staticStyle: {
        "font-size": "11px"
      }
    }, [_vm._v("+" + _vm._s(_vm.getUser(eventMember.val.refToUser).phone))]) : _vm._e(), _vm._v(" "), (_vm.isActiveUserOwnerOfEventOrAdmin()) ? _c('span', {
      staticStyle: {
        "font-size": "11px"
      }
    }, [_vm._v(", " + _vm._s(eventMember.val.price) + " р")]) : _vm._e(), _vm._v(" "), (_vm.isActiveUserOwnerOfEventOrAdmin()) ? _c('span', {
      staticStyle: {
        "font-size": "11px"
      }
    }, [_vm._v(", " + _vm._s(eventMember.val.participated == true ? 'участвовал' : 'не участвовал'))]) : _vm._e()])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.event.membering.cancels.length > 0) ? _c('DIV', {
    staticStyle: {
      "width": "100%",
      "margin-bottom": "20px",
      "float": "left"
    }
  }, [_c('div', {
    staticClass: "event-member",
    staticStyle: {
      "font-weight": "600",
      "margin": "0px 0 5px 0"
    }
  }, [_vm._v("Отмененные участия:")]), _vm._v(" "), _vm._l((_vm.event.membering.cancels), function(eventMember, keyC) {
    return _c('div', {
      key: keyC,
      staticClass: "event-member link",
      on: {
        "click": function($event) {
          _vm.goToUserCard(eventMember.val.refToUser)
        }
      }
    }, [_c('div', {
      staticClass: "event-user-avatar-small",
      style: ({
        'background-image': 'url(' + _vm.serverData.imagesGetURL(_vm.getUser(eventMember.val.refToUser).body.avatar) + ')'
      })
    }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
      staticClass: "event-user-text",
      style: ({
        'padding-top': _vm.isActiveUserOwnerOfEventOrAdmin() ? '4px' : '11px'
      })
    }, [_vm._v("\n        " + _vm._s(_vm.getUser(eventMember.val.refToUser).name)), _c('br'), _vm._v(" "), ((eventMember.val.refToUser != _vm.activeUser.id) && (_vm.getUser(eventMember.val.refToUser).phone != null)) ? _c('span', {
      staticStyle: {
        "font-size": "11px"
      }
    }, [_vm._v("+" + _vm._s(_vm.getUser(eventMember.val.refToUser).phone))]) : _vm._e(), _vm._v(" "), (_vm.isActiveUserOwnerOfEventOrAdmin()) ? _c('span', {
      staticStyle: {
        "font-size": "11px"
      }
    }, [_vm._v(", " + _vm._s(eventMember.val.price) + " р")]) : _vm._e(), _vm._v(" "), (_vm.isActiveUserOwnerOfEventOrAdmin()) ? _c('span', {
      staticStyle: {
        "font-size": "11px"
      }
    }, [_vm._v(", " + _vm._s(eventMember.val.participated == true ? 'участвовал' : 'не участвовал'))]) : _vm._e()])])
  })], 2) : _vm._e()], 1) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53224db8","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Event.vue
// module id = 359
// module chunks = 0